export default "__VITE_ASSET__B3qaaJC5__"